import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { USER_DATA_TOKEN, UserDataProvider, UserModel } from '@core';
import { DashboardMessageId, DashboardMessageQueryResult } from '../../../models/dashboard-message.query-result';

export class DashboardProfileMessageQueryHandler {
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  message(): Observable<DashboardMessageQueryResult | null> {
    return this.userDataProvider.userData$.pipe(map((user: UserModel) => this.toMessage(user)));
  }

  private toMessage(user: UserModel): DashboardMessageQueryResult | null {
    if (!user?.userId) {
      return null;
    }

    const { preferredPosition, preferredLevel } = user.playerPreferences;
    const isProfileComplete: boolean = !!user.name?.trim() && !!preferredPosition && !!preferredLevel;

    if (isProfileComplete) {
      return null;
    }

    return {
      id: DashboardMessageId.Profile,
      priority: 2,
      title: 'Uzupełnij swój profil!',
      subtitle: 'Gracze z uzupełnionym profilem mają większą szansę na zaakceptowanie prośby do gierki.',
      hasIcon: true,
      clickable: true,
      action: 'chevron'
    };
  }
}
